<template>
  <div class="main-content">
    <section class="section">
      <!-- Breadcrumb -->
      <PageHeaderNoAction/>
      <div class="section-body">
        
        <DataFilter :gridId="gridId" :isExport="false" :hasNew="true" newLink="/PersonalForm/request"></DataFilter>
        <SlickGrid :gridId="gridId" :editable="false" :frozenColumn="2" :isAutoInitData="true" baseUrl="/personal_form"/>
      </div>
    </section>
  </div>
</template>


<script>
import api from "@/api";
import { mapActions, mapGetters } from "vuex";

export default {
  title: "Personal Form List",
  access_code: "P_LIST01",
  icon: "fas fa-user-alt fa-fw",
  components: {},
  order:4,
  data() {
    return {
      gridId: "list01",
      formData: {
        staff_name: ""
      }
    };
  },
  created() {
  },
  computed: {
    ...mapGetters("grid", ["getGridById"]),

    grid() {
      return _.cloneDeep(this.getGridById(this.gridId));
    }
  },
  mounted() {},
  methods: {
    ...mapActions("grid", ["actionResetGrid", "actionSetGrid", "actionRequest"])
  }
};
</script>

<style scoped>
.section-body{
  padding-top:100px
}
</style>